let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("PXtjj")).then(() => parcelRequire('b2Bdv'));